import { useState } from 'react';

export default function useToken() {

    const getToken = () => {
        const token = localStorage.getItem('token');
        const userToken = JSON.parse(token);
        return userToken?.vToken
    };

    const getName = () => {
        const token = localStorage.getItem('token');
        const userToken = JSON.parse(token);
        return userToken?.vNombre;
    };

    const getNombreCompleto = () => {
        const token = localStorage.getItem('token');
        try {
            const userToken = JSON.parse(token);
            return userToken?.vNombre + " " + userToken?.vApellidos;
        } catch (e) {
            return "";
        }
    };

    const getShowReleaseNotes = () => {
        const token = localStorage.getItem('token');
        try {
            const userToken = JSON.parse(token);
            console.log("=== DEBUG useToken.js getShowReleaseNotes ===");
            console.log("Raw token string from localStorage:", token);
            console.log("Parsed userToken object:", userToken);
            console.log("bShowReleaseNotes value:", userToken?.bShowReleaseNotes);
            
            if (userToken?.bShowReleaseNotes === true || userToken?.bShowReleaseNotes === "true") {
                return true;
            }
            return false;
        } catch (e) {
            console.error("Error parsing token in getShowReleaseNotes:", e);
            return false;
        }
    };

    const getIdUsuario = () => {
        const token = localStorage.getItem('token');
        const userToken = JSON.parse(token);
        return userToken?.idUsuario;
    };

    const getProfileImage = () => {
        const token = localStorage.getItem('token');
        const userToken = JSON.parse(token);
        return userToken?.imagen;
    };

    const getUsuario = () => {
        const token = localStorage.getItem('token');
        const userToken = JSON.parse(token);
        return userToken?.vUsuario;
    };

    const getIdCatTipoUsuario = () => {
        const idCatTipoUsuarioString = localStorage.getItem('token');
        const idCatTipoUsuario = JSON.parse(idCatTipoUsuarioString);
        return idCatTipoUsuario?.idCatTipoUsuario;
    };
    const getEmail = () => {
        const token = localStorage.getItem('token');
        const userToken = JSON.parse(token);
        return userToken?.vEmailTrabajo || userToken?.vCorreo || '';
    };
    const [usuario, setUsuario] = useState(getUsuario());
    const [idCatTipoUsuario, setIdCatTipoUsuario] = useState(getIdCatTipoUsuario());
    const [name, setName] = useState(getName());

    const [nombreCompleto, setNombreCompleto] = useState(getNombreCompleto());

    const [idUsuario, setIdUsuario] = useState(getIdUsuario());
    const [profileImage, setProfileImage] = useState(getProfileImage());
    const [token, setToken] = useState(getToken());
    const [email, setEmail] = useState(getEmail());
    const [showReleaseNotes, setShowReleaseNotes] = useState(getShowReleaseNotes());

    const saveToken = userToken => {
        localStorage.setItem('token', JSON.stringify(userToken));
        setToken(userToken?.vToken);
        setEmail(userToken?.vEmailTrabajo || userToken?.vCorreo || '');
    };


    const saveImage = image => {
        const token = localStorage.getItem('token');

        let userToken = JSON.parse(token);
        userToken.imagen = image;
        localStorage.clear();
        localStorage.setItem('token', JSON.stringify(userToken));
        setProfileImage(userToken?.imagen);
    };
    const saveShowReleaseNotes = (show) => {
        console.log("=== DEBUG useToken.js saveShowReleaseNotes === called with:", show);
        const tokenStr = localStorage.getItem('token');
        if (tokenStr) {
            try {
                let userToken = JSON.parse(tokenStr);
                userToken.bShowReleaseNotes = show;
                localStorage.setItem('token', JSON.stringify(userToken));
                console.log("Updated token in localStorage:", JSON.stringify(userToken));
            } catch(e) {
                console.error(e);
            }
        }
        setShowReleaseNotes(show);
    };

    return {
        setToken: saveToken,
        token,
        setName,
        name,
        nombreCompleto,
        setNombreCompleto,
        setIdUsuario,
        idUsuario,
        profileImage,
        setProfileImage: saveImage,
        setUsuario,
        usuario,
        idCatTipoUsuario,
        setIdCatTipoUsuario,
        email,
        setEmail,
        showReleaseNotes,
        setShowReleaseNotes: saveShowReleaseNotes
    }
}